import Page from "../page";
import FileMonitor from "../../components/file-monitor/file-monitor";

const FileMonitorPage = () => {
  return (
    <Page>
      <FileMonitor />
    </Page>
  );
};

export default FileMonitorPage;
